import { render } from "./MainmenuBar.vue?vue&type=template&id=330f5200"
import script from "./MainmenuBar.vue?vue&type=script&lang=js"
export * from "./MainmenuBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__